let isDev = false;

try {
    isDev = process.env.NODE_ENV === 'development';
} catch (err) {
    console.log('检测环境错误', err);
}

export const IsBeta = isDev;
// export const AppName = `${Name}`;
// export const AppVersion = `${isDev ? 'b' : 'v'}${Version}`;

export const AppName = '灵鹿科技';
export const AppVersion = 'v0.1.0';
